import styled from "@emotion/styled";

export const CalculatorContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 24px;
  width: 100%;
  overflow-x: hidden;

  @media (max-width: 670px) {
    padding: 16px;
  }

  @media (max-width: 480px) {
    padding: 12px 8px;
  }
`;

export const CalculatorHeader = styled.div`
  text-align: center;
  margin-bottom: 32px;
`;

export const CalculatorTitle = styled.h1`
  font-size: 28px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  @media (max-width: 670px) {
    font-size: 24px;
    gap: 8px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

export const CalculatorSubtitle = styled.p`
  font-size: 14px;
  color: #64748b;
  text-align: center;
  padding: 0 10px;
  word-wrap: break-word;
  line-height: 1.4;

  @media (max-width: 670px) {
    font-size: 13px;
    line-height: 1.5;
  }

  @media (max-width: 480px) {
    font-size: 12px;
    padding: 0 5px;
    line-height: 1.5;
  }
`;

export const CalculatorGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 24px;
  align-items: start;

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  @media (max-width: 670px) {
    grid-template-columns: 1fr;
    gap: 14px;
    margin-bottom: 16px;
  }
`;

export const CalculatorSection = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  height: fit-content;
  overflow: hidden;

  @media (max-width: 670px) {
    padding: 16px;
    border-radius: 8px;
  }

  @media (max-width: 480px) {
    padding: 14px;
  }
`;

export const ResultsWrapper = styled.div`
  background: white;
  padding-bottom: 15px;
`;

export const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  @media (max-width: 670px) {
    font-size: 16px;
    margin-bottom: 14px;
  }
`;

export const FormGroup = styled.div`
  margin-bottom: 20px;

  @media (max-width: 670px) {
    margin-bottom: 16px;
  }
`;

export const FormLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #475569;
  margin-bottom: 8px;

  @media (max-width: 670px) {
    font-size: 13px;
    margin-bottom: 6px;
  }
`;

export const FormInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: #1e293b;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3b82f6;
  }

  &:disabled {
    background-color: #f8fafc;
    cursor: not-allowed;
  }
`;

export const FormSelect = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 14px;
  color: ${props => props.value === '' ? '#9ca3af' : '#1e293b'};
  background: white;
  cursor: pointer;
  transition: border-color 0.2s;

  &:focus {
    outline: none;
    border-color: #3b82f6;
  }
`;

export const CalculateButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background-color: #1e293b;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;

  &:hover {
    background-color: #0f172a;
  }

  &:disabled {
    background-color: #94a3b8;
    cursor: not-allowed;
  }

  @media (max-width: 670px) {
    padding: 12px 20px;
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

export const ResultsGrid = styled.div`
  display: grid;
  gap: 8px;
  margin-bottom: 16px;
`;

export const ResultItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #f1f5f9;
  gap: 10px;

  &:last-of-type {
    border-bottom: none;
  }

  @media (max-width: 670px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 12px 0;
    gap: 4px;
  }
`;

export const ResultLabel = styled.span`
  font-size: 15px;
  color: #6b7280;
  flex-shrink: 0;

  @media (max-width: 670px) {
    font-size: 14px;
  }
`;

export const ResultValue = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #111827;
  text-align: right;
  word-break: break-word;

  @media (max-width: 670px) {
    font-size: 15px;
    text-align: left;
  }
`;

export const TotalCostSection = styled.div`
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
  margin-top: 16px;
  border: 1px solid #e5e7eb;

  @media (max-width: 670px) {
    padding: 14px;
    margin-top: 14px;
  }
`;

export const TotalCostLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

export const TotalCostValue = styled.div<{ $insurance?: boolean }>`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.$insurance ? '#3b82f6' : '#1e293b'};
  margin: 4px 0;
  word-break: break-word;

  @media (max-width: 670px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const SavingsSection = styled.div`
  margin-top: 16px;
`;

export const SavingsItem = styled.div<{ $highlight?: boolean }>`
  background: ${props => props.$highlight ? '#fffbeb' : '#ffffff'};
  border: 1px solid ${props => props.$highlight ? '#fbbf24' : '#e5e7eb'};
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;

  @media (max-width: 670px) {
    padding: 14px;
    margin-bottom: 10px;
  }

  @media (max-width: 480px) {
    padding: 12px;
  }
`;

export const SavingsLabel = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 8px;
`;

export const SavingsValue = styled.div<{ $highlight?: boolean; $green?: boolean }>`
  font-size: 24px;
  font-weight: 700;
  color: ${props => props.$highlight ? '#d97706' : props.$green ? '#16a34a' : '#3b82f6'};
  margin: 6px 0;
  word-break: break-word;

  @media (max-width: 670px) {
    font-size: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;

export const SavingsDescription = styled.div<{ $highlight?: boolean; $green?: boolean }>`
  font-size: 14px;
  color: ${props => props.$highlight ? '#92400e' : props.$green ? '#16a34a' : '#3b82f6'};
  margin-top: 6px;
`;

export const PlaceholderAmount = styled.span`
  color: #d1d5db;
  font-weight: 600;
`;

export const ExportSection = styled.div`
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;

  @media (max-width: 670px) {
    flex-direction: column;
    gap: 10px;
    margin-top: 16px;
    padding-top: 14px;
  }
`;

export const ExportButton = styled.button<{ $variant?: 'primary' | 'secondary' }>`
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: ${props => props.$variant === 'primary' ? 'none' : '1px solid #e5e7eb'};
  background: ${props => props.$variant === 'primary' ? '#3b82f6' : 'white'};
  color: ${props => props.$variant === 'primary' ? 'white' : '#374151'};
  white-space: nowrap;

  &:hover {
    background: ${props => props.$variant === 'primary' ? '#2563eb' : '#f9fafb'};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 670px) {
    width: 100%;
    padding: 12px 16px;
  }
`;

export const Modal = styled.div<{ $isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: ${props => props.$isOpen ? 'flex' : 'none'};
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;

  @media (max-width: 670px) {
    padding: 12px;
  }
`;

export const ModalContent = styled.div`
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 100%;
  max-width: 500px;
  max-height: 90vh;
  overflow-y: auto;

  @media (max-width: 670px) {
    padding: 20px;
    border-radius: 8px;
    max-height: 85vh;
  }

  @media (max-width: 480px) {
    padding: 16px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

export const ModalTitle = styled.h3`
  font-size: 18px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  padding: 0;

  &:hover {
    color: #374151;
  }
`;

export const FormField = styled.div`
  margin-bottom: 16px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-bottom: 6px;
`;

export const FieldInput = styled.input`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #3b82f6;
  }
`;

export const FieldTextarea = styled.textarea`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;

  &:focus {
    outline: none;
    border-color: #3b82f6;
  }
`;

export const ModalActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;

  @media (max-width: 670px) {
    flex-direction: column-reverse;
    gap: 10px;
    margin-top: 20px;

    button {
      width: 100%;
    }
  }
`;

export const Disclaimer = styled.div`
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 16px 0 12px 0;
  font-size: 12px;
  color: #6b7280;
  line-height: 1.6;
  border-top: 1px solid #e5e7eb;
  word-wrap: break-word;
  white-space: normal;
  overflow-wrap: break-word;

  strong {
    color: #475569;
    font-weight: 600;
  }
`;

export const BreakdownSection = styled.div`
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 14px 16px;
  margin-top: 16px;
  margin-bottom: 16px;
`;

export const BreakdownTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 12px;
`;

export const BreakdownRow = styled.div<{ $isSubtotal?: boolean; $isTotal?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.$isTotal ? '10px 0 4px 0' : props.$isSubtotal ? '8px 0' : '6px 0'};
  border-top: ${props => props.$isTotal ? '2px solid #cbd5e1' : props.$isSubtotal ? '1px dashed #cbd5e1' : 'none'};
  font-weight: ${props => props.$isTotal ? '700' : props.$isSubtotal ? '600' : '400'};
  font-size: ${props => props.$isTotal ? '15px' : '14px'};
  color: ${props => props.$isTotal ? '#0f172a' : props.$isSubtotal ? '#334155' : '#64748b'};

  @media (max-width: 670px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
  }
`;

export const BreakdownLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const BreakdownValue = styled.span`
  font-variant-numeric: tabular-nums;
  color: #0f172a;
  font-weight: 600;
`;